import React from "react";
import { Helmet } from "react-helmet";
import CyberBlog from "../components/cyberBlog";

const AllProjects = ({ theme, projectList }) => {
  return (
    <div className="max-w-6xl mx-auto h-auto pt-10 pb-20">
      <Helmet>
        <title>Projects | Noor Mohammad</title>
      </Helmet>
      <div className=" flex justify-center mb-10">
        <h3
          className={`${
            theme === "dark"
              ? "text-darkTextColor decoration-darkLineColor"
              : "text-lightTextColor decoration-lightLineColor"
          } text-[32px] text-center lgl:text-left underline underline-offset-8 font-bold`}
        >
          Some of my projects:
        </h3>
      </div>
      <div className="w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 px-6">
        {projectList.map((project) => (
          <div
            key={project.id}
            className={`${
              theme === "dark"
                ? "border-darkLineColor bg-darkLineColor"
                : "border-lightTextDesignColor bg-lightTextDesignColor"
            } w-full h-80 rounded-lg overflow-hidden group relative border-2`}
          >
            <a href={project.link} target="_blank" rel="noreferrer">
              <div>
                <img
                  className="w-full h-[1200px] translate-y-0  group-hover:-translate-y-[77.5%] transition-all hover:ease-in duration-[4s] cursor-pointer object-fit"
                  src={project.image}
                  alt={project.title}
                />
              </div>
              <p
                className={`${
                  theme === "dark"
                    ? "bg-darkLineColor text-darkTextColor"
                    : "bg-lightTextDesignColor text-white"
                } absolute  hover:bg-opacity-100 text-lg font-semibold bottom-0 text-center w-full p-2 bg-opacity-70 hidden group-hover:inline-block duration-300 opacity-80 hover:opacity-100`}
              >
                {project.title}
              </p>
            </a>
          </div>
        ))}
      </div>
      <CyberBlog theme={theme} />
    </div>
  );
};

export default AllProjects;
